import React, { useEffect, useState } from "react";
import { apiCall, getProductCode, getSampleTypesdata, getCategory, getSubCategory, getProductType, uploadProductImages, toProductMediaUrl } from "../../api";
import { Typography, Box, Stack, Button, IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InputField, ProductDropDown } from ".";
import Qrcode from "../Qrcode";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import "./AddApparel.css";

export const AddApparel = (props) => {
  const history = useNavigate();
  const { user } = useAuth();

  const { productDetails } = props;
  const [sampletype, setSampletype] = useState("Select Sample Type");
  const [producttype, setProducttype] = useState("Select Product Type");
  const [category, setCategory] = useState("Select Category");
  const [subCategory, setSubCategory] = useState("Select Sub Category");
  const [typecode, setTypeCode] = useState("Select Product Code");
  const [color, setColor] = useState();
  const [size, setSize] = useState();
  const [washtype, setWashtype] = useState();
  const [season, setSeason] = useState();
  const [fobcost, setFobcost] = useState();
  const [ocnumber, setOcnumber] = useState();
  const [orderqty, setOrderqty] = useState();
  const [gpt, setGpt] = useState();
  const [comments, setComments] = useState();
  const [fabcode, setFabcode] = useState();
  const [fabricdesc, setFabricDesc] = useState();
  const [count, setCount] = useState();
  const [construction, setConstruction] = useState();
  const [composition, setComposition] = useState();
  const [gsm, setGsm] = useState();
  const [cuttable, setCuttable] = useState();

  const [stylename, setStylename] = useState("");
  const [stylecode, setStylecode] = useState("");

  const [idPrefix, setIdPrefix] = useState("IDCA");
  const [imageError, setImageError] = useState("");
  const [successMsg, setSuccesMsg] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [randomNumber, setRandomNumber] = useState(
    Math.floor(Math.random() * 10000000000)
  );
  const [productCodeList, setProductCodeList] = useState([]);
  const [sampleTypeList, setSampleTypeList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const [uniqueId, setUniqueId] = useState("");
  const [uniqueRecordId, setUniqueRecordId] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const [isQrCodeGenerated, setIsQrCodeGenerated] = useState(false);
  const [isRecordEdited, setIsRecordEdited] = useState(false);

  const { id } = useParams();

  const types = ["image/jpeg", "image/jpg", "image/png"];

  const navigate = useNavigate();

  const [imagePreviews, setImagePreviews] = useState([]);

  useEffect(() => {
    if (productDetails !== null && productDetails !== undefined) {
      console.log("Product Details Loaded:", productDetails);
      const {
        category,
        subcategory,
        color,
        comments,
        uniqueId,
        stylename,
        stylecode,
        cuttable,
        gsm,
        composition,
        construction,
        count,
        fabricdesc,
        fabcode,
        gpt,
        orderqty,
        ocnumber,
        fobcost,
        season,
        washtype,
        size,
        producttype,
        sampletype,
        typecode,
        imageUrls,
      } = productDetails;

      setIsRecordEdited(true);
      setCategory(category);
      setSubCategory(subcategory);
      setColor(color);
      setStylename(stylename);
      setStylecode(stylecode);
      setComments(comments);
      setUniqueId(uniqueId);
      setUniqueRecordId(uniqueId);
      setSampletype(sampletype);
      setTypeCode(typecode);
      setSize(size);
      setWashtype(washtype);
      setSeason(season);
      setFobcost(fobcost);
      setOcnumber(ocnumber);
      setOrderqty(orderqty);
      setGpt(gpt);
      setFabcode(fabcode);
      setCount(count);
      setFabricDesc(fabricdesc);
      setConstruction(construction);
      setComposition(composition);
      setGsm(gsm);
      setCuttable(cuttable);
      setProducttype(producttype);
      setImageUrls(imageUrls);
      const existingImages = Array.isArray(productDetails.imageItems)
        ? productDetails.imageItems
        : [];
      const existingImageUrls = Array.isArray(imageUrls) ? imageUrls : [];

      if (existingImages.length > 0) {
        setImagePreviews(
          existingImages.map((image, index) => ({
            id: String(image.id || index),
            imageId: image.id || image.imageId || "",
            file: null,
            previewUrl: image.url || image.imageUrl || "",
            originalUrl: image.url || image.imageUrl || "",
          }))
        );
      } else if (existingImageUrls.length > 0) {
        setImagePreviews(
          existingImageUrls.map((url, index) => ({
            id: `saved-${index}`,
            imageId: "",
            file: null,
            previewUrl: url,
            originalUrl: url,
          }))
        );
      }
    }
  }, [productDetails]);

  const logActivity = async (
    activityDescription,
    productName,
    uniqueRecordId
  ) => {
    try {
      const email = localStorage.getItem("userId") || "unknown";
      // Get current date and time
      const currentDate = new Date();

      // Convert current date and time to Indian Standard Time (IST)
      const istDate = currentDate.toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
      });
      await apiCall("/ActivityLogs", {
        method: "POST",
        body: JSON.stringify({
          user: email,
          activity: activityDescription,
          productName: `${productName} (${uniqueRecordId})`, // Concatenate product name and unique record id
          timestamp: istDate, // Use IST timestamp
        })
      });

      console.log("Activity logged:", activityDescription);
    } catch (error) {
      console.error("Error logging activity: ", error);
    }
  }

  const handleProductImg = (e) => {
    const newFiles = Array.from(e.target.files);
    const totalFiles = imagePreviews.length + newFiles.length;

    if (totalFiles > 4) {
      toast.warn(`You can only upload a maximum of 4 images !!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Stop further execution if the limit is exceeded
    }

    const newImagePreviews = newFiles.map((file) => ({
      previewUrl: URL.createObjectURL(file),
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
      imageId: "",
      file,
      originalUrl: null,
    }));

    setImagePreviews((prevPreviews) => [...prevPreviews, ...newImagePreviews]);
  };

  const handleRemoveImage = (imageId) => {
    setImagePreviews((prev) => prev.filter((image) => image.id !== imageId));
  };

  const renderImagePreviews = () => (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {imagePreviews.map((image, index) => (
        <Box key={image.id || index} sx={{ width: 100, position: "relative" }}>
          <img
            src={image.previewUrl}
            alt={`Preview ${index}`}
            style={{ width: "100%", height: "auto", display: "block" }}
          />
          <IconButton
            size="small"
            onClick={() => handleRemoveImage(image.id)}
            sx={{ position: "absolute", top: 0, right: 0, color: "red" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Box>
      ))}
    </Box>
  );

  const handleAddProducts = async () => {
    // Determine if the selected subcategory is 'denim'
    const isDenim = subCategory.toLowerCase() === "denim"; // Assuming 'denim' is your identifier
    
    const storedUserId = localStorage.getItem("user_id") || localStorage.getItem("userId");
    console.log('USER FROM STORAGE:', storedUserId);
    
    const createdBy = user?.id || storedUserId || 11;
    console.log('CREATED_BY USED:', createdBy);

    // Construct the document to match /designers/master/products
    const productData = {
      record_group_id: uniqueRecordId || uniqueId,
      stylename,
      stylecode,
      sampletype,
      producttype,
      category,
      sub_category: subCategory,
      product_code: uniqueId || typecode,
      size,
      color,
      washtype,
      season,
      fobcost: String(fobcost ?? ""),
      ocnumber,
      orderqty: Number(orderqty),
      gpt,
      gsm,
      comments: comments || "",
      fabcode,
      fabricdesc,
      count,
      construction,
      composition,
      cuttable,
      typecode,
      is_denim: isDenim,
      created_by: createdBy,
    };

    // Save the product data to API
    try {
      const data = await apiCall("/designers/master/products", {
        method: "POST",
        body: JSON.stringify(productData)
      });
      return data.product_id || data.data?.product_id;
    } catch (error) {
      console.error("Error writing document: ", error);
      setUploadError("Error saving the product: " + error.message);
      throw error;
    }
  };

  const extractDropdownString = (item, keyAlternatives = []) => {
    if (item === null || item === undefined) return "";
    if (typeof item === "string") return item;
    if (typeof item === "object") {
      for (const key of keyAlternatives) {
        if (item[key] !== undefined && item[key] !== null) {
          return String(item[key]);
        }
      }
      if (item.name !== undefined && item.name !== null) return String(item.name);
      if (item.value !== undefined && item.value !== null) return String(item.value);
      if (item.id !== undefined && item.id !== null) return String(item.id);

      const values = Object.values(item);
      const firstString = values.find(v => typeof v === "string");
      if (firstString) return firstString;
      if (values.length > 0) return String(values[0]);
    }
    return String(item);
  };

  const getProductCodesValues = async () => {
    try {
      const response = await getProductCode();
      const list = response?.data || response || [];
      const codes = list.map(item => extractDropdownString(item, ["product_code", "code"]));
      setProductCodeList(codes);
    } catch (error) { console.error(error); }

    if (productDetails !== null && productDetails !== undefined) {
      console.log(productDetails.producttype);
      setProducttype(productDetails.producttype);
    }
  };
  useEffect(() => {
    getProductCodesValues();
    getSampleTypeList();
    getProductTypeList();
    getCategoryList();
    getSubCategoryList();
  }, []);

  const getSampleTypeList = async () => {
    try {
      const response = await getSampleTypesdata();
      const list = response?.data || response || [];
      const types = list.map(item => extractDropdownString(item, ["sample_type", "type"]));
      setSampleTypeList(types);
    } catch (error) { console.error(error); }
  };
  const getProductTypeList = async () => {
    try {
      const response = await getProductType();
      const list = response?.data || response || [];
      const types = list.map(item => extractDropdownString(item, ["product_type", "type"]));
      setProductTypeList(types);
    } catch (error) { console.error(error); }
  };
  const getCategoryList = async () => {
    try {
      const response = await getCategory();
      const list = response?.data || response || [];
      const categories = list.map(item => extractDropdownString(item, ["category_name", "category"]));
      setCategoryList(categories);
    } catch (error) { console.error(error); }
  };
  const getSubCategoryList = async () => {
    try {
      const response = await getSubCategory();
      const list = response?.data || response || [];
      const subCategories = list.map(item => extractDropdownString(item, ["subcategory_name", "subcategory"]));
      setSubCategoryList(subCategories);
    } catch (error) { console.error(error); }
  };

  /**Handle style name change */
  const handleStyleNameChange = (e) => {
    setStylename(e.target.value);
  };
  /**Handle style Code change */
  const handleStyleCodeChange = (e) => {
    setStylecode(e.target.value);
  };
  /**Handle Style Size  change */
  const handleStyleSizeChange = (e) => {
    setSize(e.target.value);
  };
  /**Handle Style Color  change */
  const handleStyleColorChange = (e) => {
    setColor(e.target.value);
  };
  /**Handle WashType  change */
  const handleWashTypeChange = (e) => {
    setWashtype(e.target.value);
  };
  /**Handle Season  change */
  const handleSeasonChange = (e) => {
    setSeason(e.target.value);
  };
  /**Handle FOBCost  change */
  const handleFOBCostChange = (e) => {
    setFobcost(e.target.value);
  };
  /**Handle OcNumber  change */
  const handleOcNumberChange = (e) => {
    setOcnumber(e.target.value);
  };
  /**Handle OrderQty  change */
  const handleOrderQtyChange = (e) => {
    setOrderqty(e.target.value);
  };
  /**Handle GPT  change */
  const handleGPTChange = (e) => {
    setGpt(e.target.value);
  };
  /**Handle Comments  change */
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  /**Handle FabCode  change */
  const handleFabCodeChange = (e) => {
    setFabcode(e.target.value);
  };
  /**Handle FabDesc  change */
  const handleFabDesChange = (e) => {
    setFabricDesc(e.target.value);
  };
  /**Handle Count  change */
  const handleCountChange = (e) => {
    setCount(e.target.value);
  };
  /**Handle Construction  change */
  const handleConstructionChange = (e) => {
    setConstruction(e.target.value);
  };
  /**Handle Composition  change */
  const handleCompositionChange = (e) => {
    setComposition(e.target.value);
  };
  /**Handle GSM  change */
  const handleGSMChange = (e) => {
    setGsm(e.target.value);
  };
  /**Handle CuttableWidth change */
  const handleCuttableWidthChange = (e) => {
    setCuttable(e.target.value);
  };
  /**Handle sample type list */
  const handleSampleTypeList = () => {
    return sampleTypeList.map((element) => {
      return element;
    });
  };
  /**Handle  Product type list */
  const handleProductTypeList = () => {
    return productTypeList.map((element) => {
      return element;
    });
  };

  /**Handle  Category list */
  const handleCategoryList = () => {
    return categoryList.map((element) => {
      return element;
    });
  };

  const handleSubCategoryList = () => {
    return categoryList.map((element) => {
      return element;
    });
  };

  /**Handle sample type change */
  const handleSampleTypeChange = (sampleType) => {
    setSampletype(sampleType);
  };
  /**Handle Product type change */
  const handleProductTypeChange = (productType) => {
    setProducttype(productType);
  };
  /**Handle Category change */
  const handleCategoryTypeChange = (category) => {
    setCategory(category);
  };

  const handleSubCategoryTypeChange = (subcategory) => {
    setSubCategory(subcategory);
  };

  /**Handle ProductCodes change */
  const handleProductCodesChange = (ProductCodes) => {
    if (
      ProductCodes !== null &&
      ProductCodes !== undefined &&
      ProductCodes !== ""
    ) {
      const newId = `${idPrefix}-${ProductCodes}-${randomNumber
        .toString()
        .padStart(10, "0")}`;
      setUniqueId(newId);
      setUniqueRecordId(newId); // Ensure both IDs are set to the same value
    }

    setTypeCode(ProductCodes);
  };

  const handleUploadimagesToFireStore = async () => {
    if (!validateInputs()) {
      return; // Stop the submission if validation fails
    }
    // Check if all required fields are filled
    const fields = [
      stylecode,
      stylename,
      fobcost,
      color,
      size,
      washtype,
      season,
      ocnumber,
      orderqty,
      gpt,
      fabcode,
      fabricdesc,
      count,
      construction,
      composition,
      gsm,
      cuttable,
    ];

    const isAnyFieldEmpty = fields.some((field) => !field); // Check if any field is empty

    if (isAnyFieldEmpty) {
      toast.warn("Please fill all details!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
      return; // Exit the function if any field is empty
    }

    if (imagePreviews.length === 0) {
      toast.info("Please upload at least one image", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
      return; // Exit the function if no images are uploaded
    }

    let toastId = toast("Starting upload...", {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    try {
      toast.update(toastId, {
        render: "Saving product...",
        position: "top-right",
        autoClose: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      const productId = await handleAddProducts();
      if (!productId) {
        throw new Error("Product was saved but no product_id was returned.");
      }

      const uploadedImages = await Promise.all(
        imagePreviews.map((image, index) =>
          uploadImageAsPromise(image.file, index, toastId, productId)
        )
      );

      setImageUrls(uploadedImages.map((image) => image.url));
      await logActivity("Product added", stylename, uniqueRecordId);
      setIsQrCodeGenerated(true);
      setSuccesMsg("Product successfully added!");
      document.getElementById("file").value = "";
      setTimeout(() => {
        setSuccesMsg("");
      }, 5000);
      toast.success("Product added successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } catch (error) {
      toast.error(
        `An error occurred while uploading images: ${error.message}`,
        {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        }
      );
    }
  };

  //Handle waiting to upload each file using promise
  function uploadImageAsPromise(image, index, toastId, productId) {
    return new Promise(async function (resolve, reject) {
      try {
        toast.update(toastId, {
          render: `Uploading...`,
          position: "top-right",
          autoClose: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        const storedUserId = localStorage.getItem("user_id") || localStorage.getItem("userId");
        console.log('USER FROM STORAGE:', storedUserId);

        const createdBy = user?.id || storedUserId || 11;
        console.log('CREATED_BY USED:', createdBy);

        const data = await uploadProductImages({
          productId,
          images: [image],
          createdBy
        });

        const rawImage = data.image_items?.[0] || data.images?.[0] || data;
        const uploadedImageId =
          rawImage?.image_id ||
          rawImage?.imageId ||
          rawImage?.id ||
          rawImage?.product_image_id ||
          rawImage?.productImageId ||
          data.image_id ||
          data.id ||
          data.product_image_id ||
          data.productImageId ||
          (Array.isArray(data.image_ids) ? data.image_ids[0] : '') ||
          (Array.isArray(data.imageIds) ? data.imageIds[0] : '');

        const uploadedImageUrl = toProductMediaUrl(
          rawImage?.image_url ||
          rawImage?.imageUrl ||
          rawImage?.url ||
          rawImage?.location ||
          rawImage?.path ||
          data.image_urls?.[0] ||
          data.image_url ||
          data.url ||
          data.location ||
          data.Location ||
          data.s3Url ||
          data.s3_url ||
          data.path ||
          data.key
        );

        resolve({
          id: uploadedImageId || null,
          url: uploadedImageUrl,
        });
        toast.update(toastId, {
          render: "Upload successful!",
          type: "success",
          autoClose: 5000,
        });
      } catch (error) {
        reject(error);
        toast.update(toastId, {
          render: `Upload failed: ${error.message}`,
          type: "error",
          autoClose: 5000,
        });
      }
    });
  }

  const validateInputs = () => {
    const fields = [
      { value: sampletype, name: "Sample Type" },
      { value: producttype, name: "Product Type" },
      { value: category, name: "Category" },
      { value: subCategory, name: "Sub Category" },
      { value: typecode, name: "Product Code" },
    ];

    const invalidFields = fields.filter(
      (field) => field.value === "Select " + field.name || !field.value
    );

    if (invalidFields.length > 0) {
      invalidFields.forEach((field) => {
        toast.warn(`Please select a ${field.name}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      });
      return false;
    }
    return true;
  };

  const [checkboxStates, setCheckboxStates] = useState({
    styleName: false,
    styleCode: false,
    fobCost: false,
    producttype: false,
    sampletype: false,
    category: false,
    subCategory: false,
    color: false,
    size: false,
    washtype: false,
    season: false,
    ocnumber: false,
    orderqty: false,
    gpt: false,
    fabcode: false,
    fabricdesc: false,
    count: false,
    construction: false,
    composition: false,
    gsm: false,
    cuttable: false,
  });

  const handlePrintQR = () => {
    const qrElement = document.getElementById("qrCodeContainer");
    if (qrElement) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(
        "<html><head><style>h4 { text-align: center; font-size: 17px; font-weight: 1000; color: black; }</style></head><body>"
      );
      printWindow.document.write(qrElement.innerHTML);
      printWindow.document.write(`<h4>${stylecode}</h4>`);
      printWindow.document.write(`<h4>${composition}</h4>`);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error("The QR code element does not exist.");
      toast.error("Failed to print QR code: element does not exist.");
    }
  };

  const handleCheckboxChange = (event) => {
    setCheckboxStates({
      ...checkboxStates,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Box display="flex" justifyContent="center" alignItems="center">
        <div className="back-icon" onClick={() => navigate(-1)}>
          &lt; Back
        </div>
        {isQrCodeGenerated === true ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh" // Ensures that the Box takes at least the full height of the viewport
            sx={{ width: "100%" }}
          >
            <Typography variant="h4" component="h2" sx={{ mb: 4, ml: 6 }}>
              QR Successfully Generated
            </Typography>
            <div id="qrCodeContainer">
              <Qrcode
                uniqueRecordId={uniqueRecordId}
                stylename={stylename}
                stylecode={stylecode}
                fobcost={fobcost}
                producttype={producttype}
                sampletype={sampletype}
                category={category}
                subCategory={subCategory}
                color={color}
                size={size}
                washtype={washtype}
                season={season}
                ocnumber={ocnumber}
                orderqty={orderqty}
                gpt={gpt}
                fabcode={fabcode}
                fabricdesc={fabricdesc}
                count={count}
                construction={construction}
                composition={composition}
                gsm={gsm}
                cuttable={cuttable}
              />
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePrintQR}
              sx={{ mt: 7, width: 200, ml: 2 }}
            >
              Print QR
            </Button>
          </Box>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%" }}
          >
            <Typography variant="h6" sx={{ color: "#007bff;", paddingTop: 2 }}>
              {id ? "UPDATE APPAREL" : "ADD APPAREL"}
            </Typography>
            <Box sx={{ paddingLeft: 6 }}>
              <Typography
                variant="body1"
                sx={{ color: "GrayText", mt: 1, mb: 2, mr: 5 }}
              >
                Unique Document ID : {uniqueId}
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "GrayText", mt: 1, mb: 2, mr: 5 }}
              >
                Unique Product Code : {uniqueRecordId}
              </Typography>
            </Box>

            <Box sx={{ paddingLeft: 6, paddingTop: 2 }}>
              <Box sx={{ paddingBottom: 2 }}>
                <Stack spacing={5} direction="row">
                  <ProductDropDown
                    menuValues={productCodeList}
                    onChange={handleProductCodesChange}
                    dropDownText={typecode}
                    label={"Product Code"}
                  />
                  <ProductDropDown
                    menuValues={sampleTypeList}
                    onChange={handleSampleTypeChange}
                    dropDownText={sampletype}
                    label={"Sample Type"}
                  />
                  <ProductDropDown
                    menuValues={categoryList}
                    onChange={handleCategoryTypeChange}
                    dropDownText={category}
                    label={"Category"}
                  />
                  <ProductDropDown
                    menuValues={subCategoryList}
                    onChange={handleSubCategoryTypeChange}
                    dropDownText={subCategory}
                    label={"Sub Category"}
                  />
                  <ProductDropDown
                    menuValues={productTypeList}
                    onChange={handleProductTypeChange}
                    dropDownText={producttype}
                    label={"Product Type"}
                  />
                </Stack>
              </Box>

              <Stack spacing={5} direction="row">
                <InputField
                  label={"Style Name"}
                  value={stylename}
                  handleChange={handleStyleNameChange}
                />
                <InputField
                  label={"Style Code"}
                  value={stylecode}
                  handleChange={handleStyleCodeChange}
                />
                <InputField
                  label={"Style Size"}
                  value={size}
                  handleChange={handleStyleSizeChange}
                />
              </Stack>

              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"Style Colour"}
                  value={color}
                  handleChange={handleStyleColorChange}
                />
                <InputField
                  label={"Wash Type"}
                  value={washtype}
                  handleChange={handleWashTypeChange}
                />
                <InputField
                  label={"Season"}
                  value={season}
                  handleChange={handleSeasonChange}
                />
              </Stack>

              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"FOB Cost"}
                  value={fobcost}
                  handleChange={handleFOBCostChange}
                />
                <InputField
                  label={"OC Number"}
                  value={ocnumber}
                  handleChange={handleOcNumberChange}
                />
                <InputField
                  label={"Order QTY"}
                  value={orderqty}
                  handleChange={handleOrderQtyChange}
                />
              </Stack>
              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"GPT"}
                  value={gpt}
                  handleChange={handleGPTChange}
                />
                <InputField
                  label={"Comments"}
                  value={comments}
                  handleChange={handleCommentsChange}
                />
              </Stack>
              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"Fab Code"}
                  value={fabcode}
                  handleChange={handleFabCodeChange}
                />
                <InputField
                  label={"Fabric Desc"}
                  value={fabricdesc}
                  handleChange={handleFabDesChange}
                />
                <InputField
                  label={"Count"}
                  value={count}
                  handleChange={handleCountChange}
                />
              </Stack>
              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"Construction"}
                  value={construction}
                  handleChange={handleConstructionChange}
                />
                <InputField
                  label={"Composition"}
                  value={composition}
                  handleChange={handleCompositionChange}
                />
                <InputField
                  label={"Weight ( GSM / oz )"}
                  value={gsm}
                  handleChange={handleGSMChange}
                />
              </Stack>
              <Stack spacing={5} direction="row" sx={{ paddingTop: 2 }}>
                <InputField
                  label={"Cuttable Width"}
                  value={cuttable}
                  handleChange={handleCuttableWidthChange}
                />

                <input
                  type="file"
                  id="file"
                  multiple
                  onChange={handleProductImg}
                  style={{ marginTop: "26px" }}
                />
                {renderImagePreviews()}
              </Stack>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUploadimagesToFireStore}
                sx={{ mt: 4, mb: 4, ml: 60 }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};
export default AddApparel;
